/**
 * XOR Cipher implementation
 * XORs each character with a key
 */

export const xorEncrypt = (text, key = 'key') => {
  if (!key || key.length === 0) {
    throw new Error('XOR cipher requires a key');
  }
  
  let result = '';
  for (let i = 0; i < text.length; i++) {
    const textChar = text.charCodeAt(i);
    const keyChar = key.charCodeAt(i % key.length);
    result += String.fromCharCode(textChar ^ keyChar);
  }
  return result;
};

export const xorDecrypt = (text, key = 'key') => {
  // XOR is its own inverse
  return xorEncrypt(text, key);
};

export const xorCipher = {
  name: 'XOR Cipher',
  encrypt: xorEncrypt,
  decrypt: xorDecrypt,
  requiresKey: true,
  keyLabel: 'Key',
  keyType: 'text',
  defaultKey: 'secret',
  description: 'XORs each character with a repeating key'
};
